import React, { useState } from "react"

import { Slider } from "components/anti/slider/slider"
import { Card } from "components/anti/card/card"
import { useScrollAnim } from "src/components/hooks/hooks"

import location from "assets/img/development/location.svg"
import building from "assets/img/development/building.svg"

export const ProjectDetailsNearby = ({ data, loc, path, slug }) => {
    const [trigger, anim] = useScrollAnim()

    const [sliderIndex, setSliderIndex] = useState(0)

    const dataFilter = data?.map((en) => {
        if (en?.language?.slug === "en" && en.slug !== slug) {
            return (en)
        }
    })
    const allData = dataFilter?.filter(item => item)

    return (
        <>
            {allData?.length > 0 && (
                <section className="pt-main py-md-6 sc-project-nearby" ref={trigger}>
                    <div className="container">
                        <h2 className={`${anim(1)}`}>Nearby</h2>
                        <Slider
                            visibleInitial={true}
                            visibleXxlDown={true}
                            visibleXlDown={true}
                            visibleLgDown={true}
                            visibleMdDown={true}
                            dotsInitial={false}
                            dotsXxlDown={false}
                            dotsXlDown={false}
                            dotsLgDown={false}
                            dotsMdDown={false}
                            showInitial={3.25}
                            showXxlDown={3.25}
                            showXlDown={3.25}
                            showLgDown={2.5}
                            showMdDown={1}
                            arrowsInitial={true}
                            arrowsXxlDown={true}
                            arrowsXlDown={true}
                            arrowsLgDown={true}
                            arrowsMdDown={true}
                            beforeChange={val => setSliderIndex(val)}
                            className="mt-4 project-nearby d-none d-sm-block"
                        >
                            {allData?.map((project, i) => {
                                const cover = project?.projectDetailsPage?.cover?.image?.sourceUrl
                                const title = project?.projectDetailsPage?.cover?.title
                                const categories = project?.projectCategories?.nodes[0]?.name
                                // console.log("isexist", path.indexOf(project.slug))

                                return (
                                    <>
                                        {project.language.slug === "en" && path.indexOf(project.slug) < 0 && (
                                            <Card
                                                variant="overlay"
                                                img={cover}
                                                title={title}
                                                imgRatio="r-4-3"
                                                className={`${anim(2 + i)}`}
                                                key={i}
                                                link={`/development/${project?.projectCategories?.nodes[0]?.slug}/${project.slug}`}
                                            >
                                                <div className="d-flex">
                                                    <div className="d-flex mr-3">
                                                        <img src={location} className="img-fluid" alt="icon" />
                                                        <small className="text-white text-truncate">{loc}</small>
                                                    </div>
                                                    <div className="d-flex">
                                                        <img src={building} className="img-fluid" alt="icon" />
                                                        <small className="text-white text-truncate">{categories}</small>
                                                    </div>
                                                </div>
                                            </Card>
                                        )}
                                    </>
                                )
                            })}
                        </Slider>
                    </div>
                    <Slider
                        noGutter
                        visibleSmDown={false}
                        dotsSmDown={false}
                        showSmDown={1}
                        arrowsSmDown={true}
                        beforeChange={val => setSliderIndex(val)}
                        className="mt-4 project-nearby d-block d-sm-none"
                    >
                        {allData?.map((project, i) => {
                            const cover = project?.projectDetailsPage?.cover?.image?.sourceUrl
                            const title = project?.projectDetailsPage?.cover?.title
                            const categories = project?.projectCategories?.nodes[0]?.name
                            return (
                                <>
                                    {project.language.slug === "en" && (
                                        <Card
                                            variant="overlay"
                                            img={cover}
                                            title={title}
                                            imgRatio="r-4-3"
                                            className={`${anim(2 + i)}`}
                                            key={i}
                                            link={`/development/${project?.projectCategories?.nodes[0]?.slug}/${project.slug}`}
                                        >
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="d-flex">
                                                        <img src={location} className="img-fluid" alt="icon" />
                                                        <small className="text-white">{loc}</small>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="d-flex">
                                                        <img src={building} className="img-fluid" alt="icon" />
                                                        <small className="text-white">{categories}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    )}
                                </>
                            )
                        })}
                    </Slider>
                    <div className={`progress-wrapper d-block d-md-none ${anim(4)}`}>
                        <div className="bar-wrapper">
                            <div
                                className="progress-bar"
                                style={{
                                    width: `${((sliderIndex + 1) / allData?.length) * 100}%`,
                                }}
                            />
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}